import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getAllBillings,
  getDetailedBillings
} from './billing.reducer'
import Api from '../services/ApiCaller'

export function* getAllBillingsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllBillings.success(res))
    } else {
      yield put(getAllBillings.failure(message))
    }
  } catch (e) {
    yield put(getAllBillings.failure(e.message))
  }
}

export function* getDetailedBillingsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getDetailedBillings.success(res))
    } else {
      yield put(getDetailedBillings.failure(message))
    }
  } catch (e) {
    yield put(getDetailedBillings.failure(e.message))
  }
}

export default (api: any) => {
  const getAllBillingApi = (data: any) => api.get('/billing/billing-report', data)
  const getDetailedBillingsApi = (data: any) => api.get('/billing', data)
  return [
    takeLatest(getAllBillings.TRIGGER, getAllBillingsRequest, getAllBillingApi),
   takeLatest(getDetailedBillings.TRIGGER,getDetailedBillingsRequest,getDetailedBillingsApi)
  ]
}
